var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUpload = function SvgIconUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.707 1.543a1 1 0 0 0-1.414 0l-4.5 4.5a1 1 0 0 0 1.414 1.414L11 4.664V12a1 1 0 1 0 2 0V4.664l2.793 2.793a1 1 0 1 0 1.414-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 13H3.25v5.5h17.5V13h-4.625a1 1 0 1 1 0-2H21a1.75 1.75 0 0 1 1.75 1.75v6A1.75 1.75 0 0 1 21 20.5H3a1.75 1.75 0 0 1-1.75-1.75v-6A1.75 1.75 0 0 1 3 11h4.875a1 1 0 1 1 0 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.125 15.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconUpload;